const ROW_SELECTOR = "tr[data-occurrence-reason-id]";
const HANDLE_SELECTOR = "[data-order-handle]";

function csrfToken() {
  return document.querySelector("meta[name='csrf-token']")?.content;
}

async function saveOrder(tbody) {
  const url = tbody.dataset.occurrenceOrderUrl;
  if (!url) return;

  const order = Array.from(tbody.querySelectorAll(ROW_SELECTOR)).map((row) => row.dataset.occurrenceReasonId);

  try {
    await fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
      body: JSON.stringify({ order }),
      credentials: "same-origin",
    });
  } catch (error) {
    console.error("Erro ao salvar ordem dos motivos:", error);
  }
}

export const initOccurrenceReasonsOrder = () => {
  const tbody = document.querySelector("[data-occurrence-order-url]");
  if (!tbody || tbody.dataset.orderBound === "true") return;
  tbody.dataset.orderBound = "true";

  let draggingRow = null;

  tbody.querySelectorAll(ROW_SELECTOR).forEach((row) => {
    const handle = row.querySelector(HANDLE_SELECTOR);
    if (!handle) return;

    handle.setAttribute("draggable", "true");

    handle.addEventListener("dragstart", (event) => {
      draggingRow = row;
      row.classList.add("occurrence-dragging");
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", row.dataset.occurrenceReasonId || "");
    });

    handle.addEventListener("dragend", async () => {
      row.classList.remove("occurrence-dragging");
      tbody.querySelectorAll(".occurrence-drag-over").forEach((el) => el.classList.remove("occurrence-drag-over"));
      await saveOrder(tbody);
      draggingRow = null;
    });
  });

  tbody.addEventListener("dragover", (event) => {
    event.preventDefault();
    if (!draggingRow) return;

    const targetRow = event.target.closest(ROW_SELECTOR);
    if (!targetRow || targetRow === draggingRow) return;

    tbody.querySelectorAll(".occurrence-drag-over").forEach((el) => el.classList.remove("occurrence-drag-over"));
    targetRow.classList.add("occurrence-drag-over");

    const rect = targetRow.getBoundingClientRect();
    const insertAfter = event.clientY > rect.top + rect.height / 2;
    tbody.insertBefore(draggingRow, insertAfter ? targetRow.nextSibling : targetRow);
  });

  tbody.addEventListener("drop", (event) => {
    event.preventDefault();
    tbody.querySelectorAll(".occurrence-drag-over").forEach((el) => el.classList.remove("occurrence-drag-over"));
  });
};
